import { Form, InputMask, Tooltip } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

interface PayeurContactListItemFormProps {
  telephone: string;
  portable: string;
  mail: string;
  errors?: Record<string, string>;
  onChange: (e) => void;
  onError?: (errorsToAdd, errorsToRemove) => void;
}

const PayeurContactListItemForm = (props: PayeurContactListItemFormProps) => {
  const { errors, telephone, portable, mail, onChange, onError } = props;

  const handleChange = React.useCallback(
    (e) => {
      // RAZ les erreurs
      onError(null, errors);
      onChange(e);
    },
    [errors, onChange, onError],
  );

  return (
    <Form
      // @ts-expect-error
      style={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Tooltip
        trigger={
          <Form.Field
            // @ts-expect-error
            style={{
              width: 175,
            }}
          >
            <label>Portable</label>
            <InputMask
              data-testid="form-input-portable"
              // @ts-expect-error
              name="portable"
              mask="99 99 99 99 99"
              value={portable || ''}
              icon={{ name: 'mobile' }}
              style={{
                // Pour une raison que j'ignore, le Field veut pas se mettre en erreur..
                // Donc rustine le temps qu'on ait un champs de téléphone FW
                ...(_.has(errors, 'portable') && { borderColor: '#96222a' }),
              }}
              onChange={handleChange}
            />
          </Form.Field>
        }
        type={errors?.portable ? 'error' : ''}
        message={errors?.telephone}
      />
      <Tooltip
        trigger={
          <Form.Field
            // @ts-expect-error
            style={{ width: 175, padding: 0 }}
          >
            <label>Téléphone</label>
            <InputMask
              data-testid="form-input-telephone"
              // @ts-expect-error
              name="telephone"
              mask="99 99 99 99 99"
              value={telephone || ''}
              icon={{ name: 'phone' }}
              style={{
                // Pour une raison que j'ignore, le Field veut pas se mettre en erreur..
                // Donc rustine le temps qu'on ait un champs de téléphone FW
                ...(_.has(errors, 'telephone') && { borderColor: '#96222a' }),
              }}
              onChange={handleChange}
            />
          </Form.Field>
        }
        type={errors?.telephone ? 'error' : ''}
        message={errors?.telephone}
      />
      <Tooltip
        trigger={
          <Form.Input
            label="Courriel"
            data-testid="form-input-mail"
            type="email"
            icon="mail"
            name="mail"
            title=""
            value={mail}
            style={
              {
                // width: 'calc(350px + 1em)',
              }
            }
            onChange={handleChange}
          />
        }
        type={errors?.mail ? 'error' : ''}
        message={errors?.mail}
      />
    </Form>
  );
};

export default PayeurContactListItemForm;
